import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import ViewListIcon from '@mui/icons-material/ViewList';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import HomeIcon from '@mui/icons-material/Home';


export const AdminNav = () => {
    let date = new Date().toLocaleDateString();

    return <div className='container-fluid'>
        <div className=''>
            <div className='row align-items-center
                    justify-content-between px-5 
                  admin-nav text-white py-2' style={{}}>
                <div className=''>
                    {date}
                </div>
                <div className='font-weight-bold'>
                    AFBR ADMIN PANEL
                </div>
                <div>
                    Welcome, yotuo2003@gmail.com
                </div>
            </div>

        </div>
    </div>
}